/**
 * Captura erros 412 `CASH_REGISTER_REQUIRED` retornados pelo backend ao
 * tentar lançar conta a receber / aprovar orçamento sem caixa aberto.
 * Oferece ao usuário abrir o caixa antes de continuar.
 */

export type CashRegisterRequiredResponse = {
  success: false;
  code: 'CASH_REGISTER_REQUIRED';
  error: string;
  unit_id?: string | null;
};

export function isCashRegisterRequiredError(err: unknown): err is { response: { status: number; data: CashRegisterRequiredResponse } } {
  const e = err as { response?: { status?: number; data?: { code?: string } } };
  return (
    e?.response?.status === 412 &&
    e?.response?.data?.code === 'CASH_REGISTER_REQUIRED'
  );
}

export function getCashRegisterErrorMessage(err: unknown): string {
  const e = err as { response?: { data?: { error?: string; message?: string } } };
  return (
    e?.response?.data?.error ||
    e?.response?.data?.message ||
    'Abra o caixa do dia antes de prosseguir.'
  );
}

/**
 * Mostra um `confirm` nativo perguntando se o usuário quer abrir o caixa.
 * Se confirmar, navega para a tela de caixa com `?open=1` que dispara o
 * diálogo de abertura automaticamente.
 *
 * Retorna `true` quando o erro foi tratado (caso de `CASH_REGISTER_REQUIRED`),
 * `false` caso contrário (o chamador segue com o tratamento normal).
 */
export function handleCashRegisterRequired(
  err: unknown,
  navigate: (path: string) => void,
): boolean {
  if (!isCashRegisterRequiredError(err)) return false;
  const msg = getCashRegisterErrorMessage(err);
  if (typeof window !== 'undefined' && window.confirm(`${msg}\n\nDeseja abrir o caixa agora?`)) {
    navigate('/financial/cash-register?open=1');
  }
  return true;
}
